// extracted by mini-css-extract-plugin
export default {"label":"SubscriptionForm_label__TZJpc","switchBox":"SubscriptionForm_switchBox__SdGWi"};